require('../app/browser_detect.coffee')

class window.PriorityIcons
  constructor: ->
    self = this
    browserDetect = new window.BrowserDetect

    @animationSettings = [
      {
        nameCard: 'card--with-icon-1',
        elementsList: [
          {
            elementName: 'priority-icon1__2',
            duration: 0.3,
            startPosition: ['0', '100% 0%', '1'],
            endPosition: ['360', '100% 0%', '1'],
            easeFunction: 'linear'
          }
        ]
      },
      {
        nameCard: 'card--with-icon-5',
        elementsList: [
          {
            elementName: 'priority-icon5__1',
            duration: 2,
            startPosition: ['0', '83% 83%', '1'],
            endPosition: ['270', '83% 83%', '1'],
            easeFunction: 'steps'
          }
        ]
      },
      {
        nameCard: 'card--with-icon-8',
        elementsList: [
          {
            elementName: 'priority-icon-group8__1',
            duration: 0.3,
            startPosition: ['0', '50% 100%', '1'],
            endPosition: ['-10', '50% 100%', '1'],
            easeFunction: 'linear'
          },
          {
            elementName: 'priority-icon-group8__2',
            duration: 0.3,
            startPosition: ['90', '50% 50%', '0'],
            endPosition: ['0', '50% 50%', '1'],
            easeFunction: 'linear'
          }
        ]
      }
    ]

    $('.card svg').css('opacity', 1)

    if browserDetect.browser == 'Chrome'
      $('.home__priorities').addClass('with-css-animation-card')
    else
      self.animateCardIcon(undefined, 'startPosition')

      $('.card').mouseenter ()->
        self.animateCardIcon(this, 'endPosition')

      $('.card').mouseleave ()->
        self.animateCardIcon(this, 'startPosition')




  animateCardIcon: (cardElement, directionAnimation)->
    self = this
    if cardElement
      classList = $(cardElement).attr('class').split(/\s+/)

    $.each self.animationSettings, (index, item) ->
      if cardElement
        elementFlag = item.nameCard == classList[1]
      else
        elementFlag = true

      if elementFlag
        $.each item.elementsList, (indexElement, itemElement) ->
          elementSelector = $(".#{itemElement.elementName}")[0]
          if(elementSelector != undefined)
            TweenMax.to(elementSelector, itemElement.duration, {
              rotation: itemElement[directionAnimation][0],
              transformOrigin: itemElement[directionAnimation][1],
              scale: itemElement[directionAnimation][2],
              ease: if itemElement.easeFunction == 'steps' then SteppedEase.config(3) else Linear.easeNone
            })


// WEBPACK FOOTER //
// ./assets/javascripts/app/priority_icons.coffee